(function () {
  var drawer = document.querySelector('[data-sv-size-chart]');
  if (!drawer) return;

  function open() {
    drawer.classList.add('is-open');
    document.body.classList.add('sv-size-chart-open');
  }

  function close() {
    drawer.classList.remove('is-open');
    document.body.classList.remove('sv-size-chart-open');
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-sv-size-chart-trigger]')) {
      open();
      return;
    }
    if (event.target.closest('[data-sv-size-chart-close]')) {
      close();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') close();
  });
})();
